module.exports = __webpack_public_path__ + "img/ring-lvl2@2x.36541d13.jpg";